/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : TGUE
'- Date        : 26/05/2009
'- Description : Enumeration de sortie du code du bouton
'- 		     Utiliser pour tester la sortie de la fenetre generique
'-----------------------------------------------------------------------------------------
'-- MODIFICATION JSOU DEV 41548 Modification de style des popup
'-- Ce ne sont plus des liens, mais des boutons
'-----------------------------------------------------------------------------------------*/
export enum IsiButtonType {
    Yes = "ibtnYes",
    No = "ibtnNo",
    Cancel = "ibtnAnnuler",
    Apply = "ibtnAppliquer",
    Ok = "ibtnValider"
}
window.IsiButtonType = IsiButtonType;


/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : TGUE
'- Date        : 30/06/2009
'- Description : Enumeration du mode de confirmation 
'- 		     Utiliser pour definir le type de bouton a afficher dans la fenetre generique
'-----------------------------------------------------------------------------------------*/
export enum IsiModeConfirm {
    ValidateOnly = 0,
    ValidateCancel = 1,
    YesNo = 2,
    YesNoCancel = 3,
    OkOnly = 4,
    ValidateApplyCancel = 5,
    OkCancel = 6,
    SearchCancel = 7,
    Undefined = 100
}
window.IsiModeConfirm = IsiModeConfirm;

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : TGUE
'- Date        : 30/06/2009
'- Description : Enumeration de licone a afficher
'-	           Utiliser pour definir le type d'icone a afficher dans la boite Alert/Confirm  
'-----------------------------------------------------------------------------------------*/
export enum IsiIconType {
    NoIcon = 0,
    Errors = 16,
    Question = 32,
    Exclamation = 48,
    Information = 64,
    UserError = 200
}
window.IsiIconType = IsiIconType;

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : TGUE
'- Date        : 27/08/2009
'- Description : DYSF29710 - Enumeration du type de gestion du message pour laffichage dune alerte
'-----------------------------------------------------------------------------------------*/
export enum IsiMessageMode {
    ClassicMode = 0,
    SessionMode = 1
}
window.IsiMessageMode = IsiMessageMode;

// LBRI - 2011.10.21 - [DEV:45078] : nouveau menu de gauche
export enum MenuItemCode {
    SELECT = "DATA_SELECT_ITEM",
    FORM_CLOSE = "FORM_CLOSE_ITEM",
    FORM_VALIDATE = "FORM_VALIDATE_ITEM",
    FORM_CANCEL = "FORM_CANCEL_ITEM",
    FORM_REFRESH = "FORM_REFRESH_ITEM",
    DATA_CLOSE = "DATA_CLOSE_ITEM",
    FORM_ADD_ITEM = "FORM_ADD_ITEM",
    FORM_SEARCH_ITEM = "FORM_SEARCH_ITEM",
    TOP = "DATA_TOP_ITEM",
    UP = "DATA_UP_ITEM",
    DOWN = "DATA_DOWN_ITEM",
    BOTTOM = "DATA_BOTTOM_ITEM",
    PROPERTY = "DATA_PROPERTY_ITEM",
    DELETE = "DATA_DELETE_ITEM",
    EDIT_FILTERS = "EDIT_FILTERS"
};
window.MenuItemCode = MenuItemCode;

export enum IsiShortcut {
    CstMenuIWS = "MB",
    CstMenuModule = "MM",
    CstBandeau = "BA",
    CstCurseur = "MO",
    CstMenuNavigation = "ML",
    CstMenuVuesAssociees = "MD",
    CstMenuActions = "MA",
    CstMenuEcran = "S",
    CstMenuRapport = "R",
    CstMenuRaccourci = "CS"
};
window.IsiShortcut = IsiShortcut;

export enum DetailPosition {
    none = 0,
    down = 1,
    up = 2
};
window.DetailPosition = DetailPosition;

export enum DisplayZone {
    none = 0,
    master = 1,
    detail = 2,
    all = 3
};
window.DisplayZone = DisplayZone;

export enum IsiSearchType {
    Query = 1,
    Cursor = 2,
    TextConnexe = 3,
    Association = 4,
    Dissociation = 5,
    FormSearch= 6,
    None = 0
}
window.IsiSearchType = IsiSearchType;

export enum IsiScreenType {
    NonDefinit = "",
    Formulaire = "F",
    Instance = "I",
    PopUp = "P",
    VT = "T",
    VA = "A"
}
window.IsiScreenType = IsiScreenType;

// <summary>
// Définit les types de contexte d'utilisation 
// </summary>
export enum IsiUseContext  {
    // <summary>
    // Aucun contexte
    // </summary>
    none= -1,
    // <summary>
    // Contexte "full", correspont au mode de profil Intervenant (ou sans contexte), accès back-office
    // </summary>
    full= 0,
    // <summary>
    // Contexte "client", accès front-office
    // </summary>
    client= 1
}
window.IsiUseContext = IsiUseContext;

/**
 * Regroupe les différents types d'objet que l'on
 * peut trouver dans une base de données
 */
export enum SQLTypesObject {
    Function = "F",
    View = "V",
    Procedure = "P",
    Package = "PC",
    PackageBody = "PCB",
    Trigger = "T"
}
